'use client'
import { Skeleton } from '@morpho-org/ui-v6/server'
import { Button } from '@repo/ui'

import { SubSectionTitle } from '@/components/common/SubSectionTitle'

import { EXPOSURE_TABS } from '../config/VaultV2Exposure.tabs'

export default function VaultV2ExposureLoading() {
  return (
    <div
      className="gap-sm flex h-full w-full scroll-mt-[calc(var(--sticky-offset,0px)+16px)] flex-col"
      id="exposure-section"
    >
      <div className="gap-sm flex flex-wrap items-center justify-between">
        <SubSectionTitle>Exposure</SubSectionTitle>
        <div aria-hidden className="gap-sm flex flex-wrap items-center">
          {EXPOSURE_TABS.map(({ key, label }) => (
            <div key={key} className="relative">
              <Button variant="ghost" size="sm" tabIndex={-1} className="invisible">
                {label}
              </Button>
              <Skeleton className="absolute inset-0 rounded-lg" />
            </div>
          ))}
        </div>
      </div>
      <Skeleton className="h-[320px] w-[100%] rounded-[20px]" />
    </div>
  )
}
